import { DocumentKind } from 'modules/Documents/models/document';

export const ROUTES = {
  VERIFACTU: '/verifactu',
  VERIFACTU_CREATE: `/verifactu/create`,
  VERIFACTU_RECEIPT_CREATE: '/verifactu/receipt-create',
  VERIFACTU_LIST: `/verifactu/list`,
  VERIFACTU_DETAIL: '/verifactu/issued/:id',
  VERIFACTU_CREATE_TEST: `/verifactu/create?documentKind=${DocumentKind.TEST}`,

  // ⚠️ Revisar esto

  VERIFACTU_SUBMISSION: '/verifactu/submission',
  VERIFACTU_RECEIPT_SUBMISSION: '/verifactu/receipt-submission',
  VERIFACTU_SUBMISSION_TEST: '/verifactu/submission-test',
} as const;
